export const RESPONSE_GETLISTADO_FORMULARIOS = "RESPONSE_GETLISTADO_FORMULARIOS"
export const RESPONSE_GETSOLICITANTE_EMPRESA = "RESPONSE_GETSOLICITANTE_EMPRESA"